export const getDirectionScroll = (oldTopPosition = 0) => {
    const topPosition = window.scrollY;

    const result = topPosition <= oldTopPosition;
    return {result, topPosition };
};
